import React from 'react';

const CTA = ({ language }) => {
  const texts = {
    lt: {
      title: 'Kitas žingsnis atidaro paslaugą',
      subtitle: 'Takeliai ir peržiūros pastabos tęsiasi ten, kur prasideda Filmviewing.',
      cta: 'Eiti toliau',
      alt: 'Kukurūzų spragėsiai kino salės tamsoje',
    },
    en: {
      title: 'The next step opens the service',
      subtitle: 'The lanes and viewing notes continue where Filmviewing begins.',
      cta: 'Go further',
      alt: 'Popcorn in a dark cinema',
    },
  };

  const t = texts[language];

  return (
    <section className="relative overflow-hidden">
      <img
        src="https://images.unsplash.com/photo-1594909122845-11baa439b7bf?auto=format&fit=crop&w=1800&q=80"
        alt={t.alt}
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-black/70" />
      <div className="relative mx-auto max-w-3xl px-5 py-24 text-center">
        <h2 className="font-heading text-4xl text-paper sm:text-5xl">{t.title}</h2>
        <p className="mt-5 text-lg text-paper/85">{t.subtitle}</p>
        <a href="/s" className="mt-8 inline-flex bg-amber px-6 py-3 font-medium text-ink">
          {t.cta}
        </a>
      </div>
    </section>
  );
};

export default CTA;
